import { cn } from '@virginexperiencedays/tailwind';

import { IconSparkle } from '../../../icons/IconSparkle';

type StockCountdownProps = {
  className?: string;
  dataTestId?: string;
  stock: number;
};
export const StockCountdown = ({ className, stock }: StockCountdownProps) => {
  if (!stock || typeof stock !== 'number') return null;

  return (
    <div
      className={cn(
        'bg-tones-positive-100 my-4 flex items-center rounded px-4 py-2 md:my-6 md:inline-flex',
        className
      )}
      data-testid="stock-countdown"
    >
      <IconSparkle className="mr-1" width="20" height="20" />
      <span className="text-tones-positive-800 text-sm font-semibold">
        Hurry! Only {stock} remaining
      </span>
    </div>
  );
};
